import {
  Box,
  Button,
  Center,
  Link,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { BigNumber } from "ethers";
import { formatEther } from "ethers/lib/utils";
import { useEffect, useState } from "react";
import { useProvider, useSigner, useWaitForTransaction } from "wagmi";

import { ProcessingModal } from "../ProcessingModal";
import analyticsInstance from "../../config/analytics";
import { formatToDisplay } from "../../helpers/numbers";
import { getStreams } from "../../helpers/streams";
import { NUM_CONFIRMATIONS } from "../../config/constants";
import { stopDCA } from "../../helpers/dca";
import { getSuperfluidConsoleLink } from "../../config/resolver";
import { useSupportedNetwork } from "../../helpers/hooks/network";

function Streams({ account }) {
  const [streams, setStreams] = useState();
  const [tx, setTx] = useState();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const provider = useProvider();
  const signer = useSigner();
  const { isSupportedNetwork, chain } = useSupportedNetwork();
  const { status } = useWaitForTransaction({ hash: tx?.hash, confirmations: NUM_CONFIRMATIONS });

  useEffect(() => {
    if (!isSupportedNetwork || !chain || status === "loading" || status === "error") return;

    setStreams(null);
    getStreams(provider, chain.id, account)
      .then(setStreams)
      .catch((e) => {
        // TODO: error handling
        console.log("error fetching streams", e);
        analyticsInstance.track("StreamsGetError", {
          account: account,
          error: e,
        });
      });
  }, [account, chain, isSupportedNetwork, provider, status]);

  return (
    <Box py="2em">
      <Text fontSize="xl" fontWeight="bold" mb="0.5em">
        🏦 Streams
      </Text>

      {chain && streams ? (
        <>
          {streams.length > 0 ? (
            <TableContainer>
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>pair</Th>
                    <Th isNumeric>daily amount streamed</Th>
                    <Th>actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {streams.map((s, idx) => {
                    return (
                      <Tr key={idx}>
                        <Td>
                          <Link
                            href={getSuperfluidConsoleLink(chain.id, s.contractAddress)}
                            onClick={() => analyticsInstance.track("SuperfluidConsoleLinkClicked")}
                            isExternal
                          >
                            {s.sourceToken}/{s.targetToken}
                          </Link>
                        </Td>
                        {s.flowRate.gt(0) ? (
                          <>
                            <Td isNumeric>
                              {formatToDisplay(formatEther(s.flowRate.mul(BigNumber.from(60 * 60 * 24))))}
                            </Td>

                            <Td>
                              <Button
                                size="xs"
                                colorScheme="red"
                                onClick={() => {
                                  onOpen();
                                  setTx(null);
                                  stopDCA(chain.id, signer.data, account, s.sourceToken, s.contractAddress)
                                    .then((result) => {
                                      setTx(result);
                                    })
                                    .catch((err) => {
                                      // TODO: do something on error
                                      setTx({ txError: err });

                                      analyticsInstance.track("StreamStopError", { error: err });
                                    });

                                  analyticsInstance.track("StreamStopClicked");
                                }}
                              >
                                stop
                              </Button>
                              <ProcessingModal isOpen={isOpen} onClose={onClose} tx={tx} />
                            </Td>
                          </>
                        ) : (
                          <Td colSpan={3}>
                            <Center>
                              <Text fontSize="xs">You're not BTFDCA'ing this pair.</Text>
                            </Center>
                          </Td>
                        )}
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <Text>No streams to display.</Text>
          )}
        </>
      ) : (
        <Spinner />
      )}
    </Box>
  );
}

export default Streams;
